// "Recently viewed" — kept in this browser only (no account needed).
const KEY = 'mithralaya.recentlyViewed';
const MAX = 12;

const read = () => {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
};

export const getRecentlyViewed = (excludeId) =>
  read().filter((p) => p && p._id && String(p._id) !== String(excludeId || ''));

// Store just what a product card needs
export const addRecentlyViewed = (product) => {
  if (!product?._id) return;
  const entry = {
    _id: product._id,
    slug: product.slug,
    name: product.name,
    images: (product.images || []).slice(0, 1),
    price: product.price,
    mrp: product.mrp,
    subCategory: product.subCategory,
    catalogType: 'textile',
    colors: (product.colors || []).slice(0, 1),
    viewedAt: Date.now()
  };
  const next = [entry, ...read().filter((p) => String(p._id) !== String(product._id))].slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch (e) {
    /* storage full/blocked — ignore */
  }
};

export const clearRecentlyViewed = () => {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    /* ignore */
  }
};

// Recent searches for the search box
const SEARCH_KEY = 'mithralaya.recentSearches';
export const getRecentSearches = () => {
  try {
    const list = JSON.parse(localStorage.getItem(SEARCH_KEY) || '[]');
    return Array.isArray(list) ? list.slice(0, 6) : [];
  } catch (e) {
    return [];
  }
};
export const addRecentSearch = (q) => {
  const term = String(q || '').trim();
  if (!term) return;
  const next = [term, ...getRecentSearches().filter((t) => t.toLowerCase() !== term.toLowerCase())].slice(0, 6);
  try {
    localStorage.setItem(SEARCH_KEY, JSON.stringify(next));
  } catch (e) {
    /* ignore */
  }
};
export const clearRecentSearches = () => {
  try {
    localStorage.removeItem(SEARCH_KEY);
  } catch (e) {
    /* ignore */
  }
};
